import { HomeChargingSupportingDocument } from "./homeChargingSupportingDocumentsAPI";

export const fakeHomeChargingSupportingDocuments: HomeChargingSupportingDocument[] =
  [
    {
      driverUuid: "c1000000-0000-4000-8000-000000000001",
      firstName: "Camille",
      lastName: "Durand",
      chargesCount: 8,
      totalEnergy: 154.8,
      reimbursementAmount: 30.96,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000002",
      firstName: "Jerome",
      lastName: "Bell",
      chargesCount: 2,
      totalEnergy: 108.6,
      reimbursementAmount: 14.24,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000003",
      firstName: "Pierre",
      lastName: "Dupont",
      chargesCount: 3,
      totalEnergy: 61,
      reimbursementAmount: 12.2,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000004",
      firstName: "Thierry",
      lastName: "Sabard",
      chargesCount: 3,
      totalEnergy: 52.9,
      reimbursementAmount: 10.58,
      supportingDocument: null,
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000005",
      firstName: "Aude",
      lastName: "Bousquet",
      chargesCount: 5,
      totalEnergy: 96.4,
      reimbursementAmount: 19.28,
      supportingDocument: {
        createdAt: "2026-10-02T08:00:00.000Z",
        createdBy: {
          firstName: "Étienne",
          lastName: "Roussel",
        },
      },
    },
    {
      driverUuid: "c1000000-0000-4000-8000-000000000006",
      firstName: "Lucas",
      lastName: "Martin",
      chargesCount: 0,
      totalEnergy: 0,
      reimbursementAmount: 0,
      supportingDocument: null,
    },
  ];
